import _ from 'lodash'

// TODO: 
export default function keyRingPositionGenerator ({
	angle_start, angle_step,
	radius, center, onKeyPositionGenerated
}){
	let stepIndex = 0
	let midStepIndex = 0
	let angle = 0

	const addSpace = () => { stepIndex++ }
	const addMidSpace = () => { midStepIndex++ }

	const positions = []

	const generateKeyPosition = () => {
		const angle = angle_start + stepIndex*(angle_step) + midStepIndex*(angle_step/2)

		const x = center.x + radius * Math.cos(angle)
		const y = center.y + radius * Math.sin(angle)

		const key_angle = Math.atan2(y - center.y, x - center.x)

		const position = { x: x, y: y, angle: key_angle }

		onKeyPositionGenerated(position)

		positions.push(position)

		addSpace()
	}

	addMidSpace()

	_.times(3, ()=>{
		addMidSpace()

		generateKeyPosition()
		addMidSpace()

		_.times(7, ()=> {
			_.times(3, generateKeyPosition)

			addMidSpace()

			generateKeyPosition()
			generateKeyPosition()

			addMidSpace()
		})

		_.times(3, generateKeyPosition)

		addSpace()
	})

	return positions
}